import { FC } from 'react'
import { motion } from 'framer-motion'

const Hero: FC = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center pt-20">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url('/assets/home_page_bgc.webp')`,
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Your Body. Your Confidence. Refined.
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-10 font-light max-w-2xl mx-auto">
            Experience advanced body-contouring and wellness treatments in Larnaca.
          </p>
          
          <a
            href="#contact"
            className="inline-block bg-primary text-white px-8 sm:px-10 py-4 rounded-full font-semibold uppercase tracking-wider text-sm sm:text-base transition-all duration-300 hover:bg-white hover:text-primary hover:shadow-xl transform hover:-translate-y-1"
          >
            Book Appointment
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
            className="w-1.5 h-1.5 bg-white rounded-full"
          />
        </div>
      </motion.div>
    </section>
  )
}

export default Hero
